export default "__VITE_ASSET__DowmvTeO__"